import { defineComponent as B, inject as S, computed as r, useSlots as x, useAttrs as L, createBlock as n, openBlock as a, unref as s, mergeProps as P, withCtx as c, createCommentVNode as u, normalizeClass as g, renderSlot as d } from "vue";
import { fallbackCommonSize as V, fallbackBasicColor as j } from "./highrise66.mjs";
import { JSONtoNaiveVars as h } from "./highrise297.mjs";
import z from "./highrise121.mjs";
import "./highrise58.mjs";
import { createButtonVariantStyle as A } from "./highrise347.mjs";
import { getButtonSizeStyles as W, getIconOnlyButtonPaddings as R, getLinkButtonSize as E } from "./highrise348.mjs";
import { fallbackVariant as k } from "./highrise349.mjs";
import { COMPONENT_NAME as M } from "./highrise174.mjs";
import F from "./highrise350.mjs";
import H from "./highrise81.mjs";
const I = B({
  name: M.BUTTON,
  inheritAttrs: !0
}), et = /* @__PURE__ */ B({
  ...I,
  props: {
    id: {},
    size: {},
    color: { default: "gray" },
    variant: { default: "secondary" },
    disabled: { type: Boolean, default: void 0 },
    loading: { type: Boolean, default: void 0 },
    link: { type: Boolean, default: void 0 },
    href: {},
    target: {},
    fullWidth: { type: Boolean }
  },
  emits: ["click"],
  setup(w) {
    const e = w, _ = S("hr-form", null), O = S("hr-section-footer-size", null), p = r(() => e.size || O || _ || "sm"), o = x(), v = L(), b = r(() => ({
      color: j(e.color),
      size: V(p.value),
      variant: k(e.variant)
    })), l = r(() => {
      const { size: t, variant: i, color: f } = b.value, N = W(t), T = A(f, i);
      let m = {
        ...h(N),
        ...h(T)
      };
      return i === "text" && Object.assign(m, h(E())), o.icon && !o.default && Object.assign(m, R(t)), m;
    }), C = Object.keys(v).reduce(
      (t, i) => ((i === "class" || i.startsWith("data-") || i.startsWith("aria-")) && (t[i] = v[i]), t),
      {}
    ), $ = r(() => ({
      [`hr-button--${k(e.variant)}`]: !0,
      "hr-button--link": e.link || e.href,
      "hr-button--icon-only": (o.iconLeft || o.iconRight) && !o.default,
      [`hr-button--${p.value}`]: !0,
      "hr-button--full-width": e.fullWidth
    })), y = r(() => ({
      lg: {
        size: "2xl",
        weight: "semibold"
      },
      md: {
        size: "lg",
        weight: "semibold"
      },
      sm: {
        size: "lg",
        weight: "semibold"
      },
      xs: {
        size: "md",
        weight: "semibold"
      },
      "2xs": {
        size: "sm",
        weight: "semibold"
      },
      "3xs": {
        size: "xs",
        weight: "semibold"
      }
    })[b.value.size]);
    return (t, i) => (a(), n(s(F), P({
      id: t.id,
      disabled: e.disabled,
      loading: e.loading,
      style: l.value,
      class: $.value,
      tag: e.href ? "a" : "button",
      href: e.href,
      target: e.target
    }, { ...s(C) }, {
      onClick: i[0] || (i[0] = (f) => t.$emit("click", f))
    }), {
      default: c(() => [
        s(o).icon && !s(o).default ? (a(), n(z, {
          key: 0,
          size: l.value["--n-icon-size"],
          color: l.value["--n-icon-color"],
          class: g("hr-icon")
        }, {
          default: c(() => [
            d(t.$slots, "icon", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["size", "color"])) : u("", !0),
        s(o).iconLeft ? (a(), n(z, {
          key: 1,
          size: l.value["--n-icon-size"],
          color: l.value["--n-icon-color"],
          class: g("hr-icon-left")
        }, {
          default: c(() => [
            d(t.$slots, "iconLeft", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["size", "color"])) : u("", !0),
        s(o).default && !s(o).icon ? (a(), n(s(H), {
          key: 2,
          class: "hr-button__content-default-slot",
          size: y.value.size,
          weight: y.value.weight
        }, {
          default: c(() => [
            d(t.$slots, "default", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["size", "weight"])) : u("", !0),
        s(o).iconRight ? (a(), n(z, {
          key: 3,
          size: l.value["--n-icon-size"],
          color: l.value["--n-icon-color"],
          class: g("hr-icon-right")
        }, {
          default: c(() => [
            d(t.$slots, "iconRight", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["size", "color"])) : u("", !0)
      ]),
      _: 3
    }, 16, ["id", "disabled", "loading", "style", "class", "tag", "href", "target"]));
  }
});
export {
  et as default
};
